export const MENU_TOAST_MOBILE_OFFSET = 0;
export const MENU_TOAST_MOBILE_ANDROID_OFFSET = 45;
export const MENU_TOAST_DESKTOP_OFFSET = 40;
